import { TokenHelper } from "../Helper/TokenHelper";

class LogoutManager {
    private static _instance: LogoutManager | null = null;
    private readonly logoutButtonSelector: string = '.account__disconnect';

    private constructor() {
        this.initialize();
    }

    public static get Instance(): LogoutManager {
        if (!LogoutManager._instance) {
            LogoutManager._instance = new LogoutManager();
        }
        return LogoutManager._instance;
    }

    private initialize(): void {
        document.addEventListener('DOMContentLoaded', () => {
            const logoutButton = document.querySelector(this.logoutButtonSelector) as HTMLElement;

            if (logoutButton) {
                logoutButton.addEventListener('click', this.handleLogout.bind(this));
            }
        });
    }

    private async handleLogout(event: MouseEvent): Promise<void> {
        try {
            await TokenHelper.Instance.Logout();
            window.location.href = '/';
        } catch (error) {
            console.error('Error during logout:', error);
        }
    }
}

// Initialize the logout manager
LogoutManager.Instance;